import React, { ComponentState, useEffect, useRef, useState } from "react";
import CapReportFilters, { CapMappedDataByWeek } from "./cap-report-filtrs";
import { useDispatch, useSelector } from "react-redux";
import { saveCapServiceReport } from "src/redux/actions";
import CapServiceDataTable from "./caps-report-data-table";
import { CapNoteReportData } from "src/dataModels/reportsModel";
import { TableRowsLoader } from "src/control-components/custom-skelton";
import NoteneticLinkText from "src/control-components/notenetic-link-text";
import pako from "pako";
import { puppeteerService } from "src/services/puppeteerPdfService";
import { showError } from "src/util/utility";
import moment from "moment";
import noPlan from "../../assets/images/undraw_blank_canvas_re_2hwy 1.png";

async function groupByWeeks(startDate, endDate, data) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const weeks: CapMappedDataByWeek[] = [];
  let currentStart = new Date(start);

  while (currentStart <= end) {
    let currentEnd = new Date(currentStart);
    currentEnd.setDate(currentEnd.getDate() + 6);
    if (currentEnd > end) currentEnd = new Date(end);
    const weekData = data.filter((item) => {
      const serviceDate = new Date(item.serviceDate);
      return serviceDate >= currentStart && serviceDate <= currentEnd;
    });
    weeks.push({
      weekStart: moment(currentStart).format("YYYY-MM-DD"),
      weekEnd: moment(currentEnd).format("YYYY-MM-DD"),
      data: weekData,
    });
    currentStart.setDate(currentStart.getDate() + 7);
  }

  return weeks;
}

function CapDocReport() {
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const { loadingStateDocList } = state["LoaderReducer"];
  const { capNoteReportData } = state["DocumentReducer"];
  const [startDate, setStartDate] = useState();
  const [endDate, setEnDate] = useState();
  const [mappedReportData, setMappedReportData] =
    useState<CapMappedDataByWeek[]>();
  const dispatch = useDispatch();
  const [clientData, setClientData] = useState<CapNoteReportData>();
  const [loadingPrint, setLoadingPrint] = useState(false);
  useEffect(() => {
    if (capNoteReportData && capNoteReportData.length > 0) {
      mapReportData(capNoteReportData);
    }
  }, [capNoteReportData]);

  async function mapReportData(reportData) {
    setClientData(reportData[0]);
    const mappedData: CapMappedDataByWeek[] = await groupByWeeks(
      startDate,
      endDate,
      reportData
    );
    setMappedReportData(mappedData);
    dispatch(saveCapServiceReport([]));
  }
  let _element: any[] = [];

  const exportToPdf = async () => {
    try {
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules)
              .map((rule) => rule.cssText)
              .join("");
          } catch (e) {}
          return "";
        })
        .join("\n");

      const element = _elementRef.current;
      const metaD = {
        clientName: `${clientData?.lName},  ${clientData?.fName}`,
        capService: clientData?.capService,
      };

      const formattedElement = {
        html: element?.outerHTML,
        title: "CAP Service Report",
        author: "Notenetic Team",
        styles,
        metaData: metaD,
      };
      setLoadingPrint(true);
      const body = JSON.stringify({ elements: [formattedElement] });
      const compressedBody = pako.gzip(body);
      const result = await puppeteerService.generateCapReportPdf(
        compressedBody
      );
      setLoadingPrint(false);
      if (result !== true) {
        showError(result);
      }
    } catch (error) {
      showError(error);
    }
  };
  const _elementRef = useRef<any>(null);

  return (
    <div>
      <CapReportFilters
        clearClick={() => {
          setLoadingPrint(false);
          setMappedReportData(undefined);
        }}
        setStartDate={setStartDate}
        setEndDate={setEnDate}
        exportClick={() => {}}
      ></CapReportFilters>

      {loadingStateDocList ? (
        <TableRowsLoader rowsNum={12} />
      ) : !loadingStateDocList &&
        startDate &&
        endDate &&
        (!mappedReportData || mappedReportData?.length < 1) ? (
        <div className="blueTheme">
          <div className="message-not-found mt-3">
            <img src={noPlan} alt="no plan" />
            <h6 className="mt-3 fw-bold  ">No Data available</h6>
          </div>
        </div>
      ) : (
        mappedReportData &&
        mappedReportData.length > 0 &&
        clientData && (
          <div>
            <div className="text-right mb-2 mt-4 mr-4">
              {loadingPrint ? (
                <>Please wait while preparing pdf</>
              ) : (
                <NoteneticLinkText
                  text="Export"
                  preset="blue_bold"
                  onClick={exportToPdf}
                />
              )}
            </div>
            <div
              ref={(div) => {
                _elementRef.current = div;
              }}
            >
              <div
                className="k-pdf-export"
                ref={(div) => {
                  _element.push(div);
                }}
              >
                {mappedReportData.map((byWeekData) => {
                  return (
                    <div>
                      <CapServiceDataTable
                        dataDocument={byWeekData}
                        clientData={clientData}
                        isPrinting={loadingPrint}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default CapDocReport;
